import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'monetaryunitprefix' })
export class MonetaryUnitPrefixPipe implements PipeTransform {

    lang = this.translate.currentLang;

    positivePowerNames = [];
    positivePowerSymbols = [];
    negativePowerNames = [];
    negativePowerSymbols = [];

    constructor(
        private translate: TranslateService
    ) { }

    transform(value, significantDigits, useNames, unit) {

        if (this.lang === 'pt') {
            this.positivePowerNames = ['', 'thousands', 'millions', 'billions', 'trillions'];
            this.positivePowerSymbols = ['', ' mil', ' mi', ' bi', ' tri'];
            this.negativePowerNames = ['', 'thousands', 'millions', 'billions', 'trillions'];
            this.negativePowerSymbols = ['', ' mil', ' mi', ' bi', ' tri'];
        } else if (this.lang === 'en') {
            this.positivePowerNames = ['', 'thousands', 'millions', 'billions', 'trillions'];
            this.positivePowerSymbols = ['', ' K', ' M', ' B', ' T'];
            this.negativePowerNames = ['', 'thousands', 'millions', 'billions', 'trillions'];
            this.negativePowerSymbols = ['', ' K', ' M', ' B', ' T'];
        } else if (this.lang === 'es') {
            this.positivePowerNames = ['', 'thousands', 'millions', 'billions', 'trillions'];
            this.positivePowerSymbols = ['', ' K', ' mills', ' mil mills', ' billones'];
            this.negativePowerNames = ['', 'thousands', 'millions', 'billions', 'trillions'];
            this.negativePowerSymbols = ['', ' mil', ' mills', ' mil mills', ' billones'];
        }

        if (typeof value === 'number' && value !== 0) {
            const suffixIndex = Math.floor(Math.log10(Math.abs(value)) / 3);
            if (Number.isFinite(suffixIndex) && Math.abs(suffixIndex) < this.positivePowerNames.length) {
                const adjustedValue = value / Math.pow(10, suffixIndex * 3);
                const suffix =
                    suffixIndex >= 0 ?
                        (useNames ? this.positivePowerNames[suffixIndex] : this.positivePowerSymbols[suffixIndex]) :
                        (useNames ? this.negativePowerNames[suffixIndex] : this.negativePowerSymbols[suffixIndex]);
                return new Intl.NumberFormat(undefined, { style: 'decimal', maximumSignificantDigits: significantDigits || 3 }).format(adjustedValue) + suffix + (unit || '');
            }
        }
        return value || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/monetary-unit-prefix.pipe.ts